import React from 'react'
import { useTranslation } from 'react-i18next'
import { ATTableHeader } from './ATTableProps'

const TableHeader: React.FC<ATTableHeader> = ({ columns }) => {
  const { t } = useTranslation(['translation'])

  function getColumnTitle(column: any, columnIndex: number) {
    if (typeof column.title === 'function') {
      return column.title(columnIndex)
    }
    return t(column.title)
  }

  return (
    <tr>
      {columns?.map((column, columnIndex: number) => (
        <th key={`table-head-cell-${columnIndex}`} style={column?.style}>
          {getColumnTitle(column, columnIndex)}
        </th>
      ))}
    </tr>
  )
}
export default TableHeader
